import React, { useCallback, useState } from 'react'
import axios from 'lib/axios'
import ToggleCheckbox from 'components/QuestionnaireRequest/AdminNew/components/checkbox'

const GenericFormId = ({ buildingId, genericFromId, updateGenericFormId, updating, setUpdating }) => {
  const [value, setValue] = useState(genericFromId || '')
  const onBlur = useCallback(async (e) => {
    const inputVal = e.currentTarget.value.trim()
    setUpdating(true)
    const url = `/buildings/${buildingId}/questionnaires/update_generic_form_id`
    try {
      await axios.post(url, {
        generic_form_id: inputVal,
      })
      updateGenericFormId(inputVal)
    } catch (error) {
      console.log(error)
    }
    setUpdating(false)
  }, [updateGenericFormId, setUpdating])

  return (
    <input
      type="text"
      placeholder="form ID"
      style={{ width: 110 }}
      value={value}
      onChange={(e) => setValue(e.currentTarget.value)}
      onBlur={onBlur}
      readOnly={updating}
    />
  )
}

const EnableCheckbox = ({ buildingId, enabled, updateEnabled, updating, setUpdating }) => {
  const changeValue = async (enabled) => {
    try {
      setUpdating(true)
      const url = `/buildings/${buildingId}/questionnaires/enable_override_generic_form`
      await axios.post(url, { override_generic_form: enabled ? 1 : 0 })
      updateEnabled(enabled)
    } catch (error) {
      console.log(error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <div className="dome-d-flex dome-align-start">
      <ToggleCheckbox
        label="override generic form"
        defaultChecked={enabled}
        disabled={updating}
        onChange={(e) => changeValue(e.target.checked)}
      />
    </div>
  )
}

export default function OverrideGenericForm({
  buildingId,
  overrideGenericForm,
  updateOverrideGenericForm,
  genericFormId,
  updateGenericFormId,
}) {
  const [updating, setUpdating] = useState(false)

  return (
    <div className="questionnaire-admin-general-row">
      <EnableCheckbox
        buildingId={buildingId}
        enabled={overrideGenericForm}
        updateEnabled={updateOverrideGenericForm}
        updating={updating}
        setUpdating={setUpdating}
      />
      {overrideGenericForm && (
        <GenericFormId
          buildingId={buildingId}
          genericFromId={genericFormId}
          updateGenericFormId={updateGenericFormId}
          updating={updating}
          setUpdating={setUpdating}
        />
      )}
    </div>
  )
}
